"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-arrow-left-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M26 21v5l-16-7.5L26 12v5h11.375v4H26z", fill: "#4C4C4C" }),
            _react2.default.createElement("path", { d: "M19 37C9.059 37 1 28.941 1 19S9.059 1 19 1s18 8.059 18 18-8.059 18-18 18z", stroke: "#000", strokeWidth: "2" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-arrow-left-on.js
// module id = 1828
// module chunks = 0